<template>
  <div class="footer-wrapper">
    <div class="footer-icons">
      <div class="icon-fb">
        <a href="https://www.instagram.com/splendorwrld/"><b-icon-instagram /></a>
      </div>
      <div class="icon-ig">
        <a href="https://www.facebook.com/splendorwrld"><b-icon-facebook /></a>
      </div>
    </div>
    <div class="link-wrapper">
      <span class="footer-link"><a @click="$router.push({ name: 'Rules' })">{{ strings.footer.rules_ }}</a></span>
      <span class="footer-link"><a @click="$router.push({ name: 'Cookies' })">{{ strings.footer.privacy_ }}</a></span>
      <span class="footer-link"><a @click="$router.push({ name: 'Returns' })">{{ strings.footer.returns_ }}</a></span>
      <span class="footer-link"><a @click="$router.push({ name: 'Contact' })">{{ strings.footer.contact_ }}</a></span>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapGetters([
      'strings'
    ])
  }
}
</script>

<style scoped lang="scss">
.footer-navbar {
  width: 100%;
  height: 160px;
}
.footer-icons {
  width: 100%;
  height: 80px;
  text-align: center;
}
.footer-icons a {
  color: inherit;
}
.icon-fb {
  display: inline-block;
  font-size: 2.5rem;
  margin-right: 40px;
  cursor: pointer;
}
.icon-ig {
  display: inline-block;
  font-size: 2.5rem;
  cursor: pointer;
}
.link-wrapper {
  width: 100%;
  margin-bottom: 40px;
}
.footer-link {
  font-size: 0.8rem;
  letter-spacing: 2px;
  text-transform: uppercase;
  display: block;
  width: 100%;
  cursor: pointer;
  padding-top: 20px;
}
.footer-link:hover {
  text-decoration: underline;
}

@media (min-width: 992px) {
  .footer-wrapper {
    width: 100%;
    height: 200px;
    clear: both;
  }
  .footer-icons {
    width: 25%;
    float: left;
    padding-top: 100px;
  }
  .icon-fb {
    float: left;
    font-size: 2.5rem;
    margin-left: 100px;
    margin-right: 40px;
    cursor: pointer;
  }
  .icon-ig {
    float: left;
    font-size: 2.5rem;
    cursor: pointer;
  }
  .link-wrapper {
    width: 75%;
    float: left;
    padding-top: 100px;
  }
  .footer-link {
    float: left;
    width: calc(100% / 4);
  }
}
</style>
